import EventEmitter from 'eventemitter3';
import styles from './styles.module.scss';
import type { Token } from '../../core/token';

export interface KLineTooltipItem {
  color: string;
  name?: string;
  value: string;
}

type Config = {
  token?: Partial<Token>;
};

type Option = {
  data: KLineTooltipItem[];
};

type EventTypes = {
  change: (dataItem: Option['data']) => void;
};

export default class KLineTooltip extends EventEmitter<EventTypes> {
  private __$dom!: HTMLElement;

  private __config: Config;

  constructor($container: HTMLElement, config: Config) {
    super();

    this.__$dom = $container;
    $container.classList.add(styles.container);
    this.__config = config;
  }

  private __update(data: KLineTooltipItem[]) {
    if (!data.length) {
      return;
    }

    let color: string;
    if (this.__config?.token?.dvHXKLine?.tooltip?.text?.color) {
      color = this.__config.token.dvHXKLine.tooltip.text.color;
    }

    this.__$dom.style.display = 'flex';
    this.__$dom.innerHTML = data
      ?.map(item => {
        if (!item.name) {
          return `
          <div>
            <span style='color: ${color || item.color}'>${item.value}</span>
          </div>
        `;
        }

        return `
          <div>
            <span style='color: ${color || 'undefined'}'>${item.name}:</span><span style='color: ${
              item.color
            }; font-weight: 500;'>${item.value}</span>
          </div>
        `;
      })
      .join('');
  }

  show(data: KLineTooltipItem[] = []) {
    this.__update(data);
  }

  hide() {
    this.__$dom.style.display = 'none';
  }

  destroy() {
    const self = this;
    self.__$dom.innerHTML = '';
  }
}
